
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2454',
  depVersions: {
  "customer-portal-app": "static-1.2454",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.473",
  "data-fetching-client": "static-1.9713",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25516",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5638",
  "hs-test-utils": "static-1.8064",
  "hub-http": "static-1.6270",
  "hub-http-shared-msw-handlers": "static-1.10078",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18364",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11521",
  "I18n": "static-7.1633",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6512",
  "payment-link-components": "static-1.23638",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7090",
  "quartz-core": "static-1.6309",
  "quartz-i18n": "static-1.765",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10256",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5382",
  "rich-text-lib": "static-1.19912",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18064",
  "ui-components-test-utils": "static-1.5658",
  "UIComponents": "static-3.8467",
  "foundations-assets": "static-1.4917",
  "foundations-components": "static-1.8022",
  "foundations-theming": "static-1.4471",
  "foundations-theming-specialty": "static-1.2187",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1002",
  "quartz-config": "static-1.868",
  "quartz-routing": "static-1.520",
  "quick-fetch": "static-1.3955",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16725",
  "rpc-client-utils": "static-1.4700",
  "sanitize-text": "static-1.8190",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4810",
  "ui-addon-react-router-dom": "static-1.9589",
  "usage-tracker": "static-1.7397",
  "usage-tracker-anonymous": "static-1.5814",
  "usage-tracker-core": "static-1.7247",
  "video-components-external": "static-1.11448",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3437",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3367",
  "quartz-webpack": "static-1.3314",
  "bend-plugin-quartz-routing": "static-1.168",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7723",
  "frontend-preferences-client": "static-1.7974",
  "laboratory-lib": "static-3.7203",
  "onboarding-scopes": "static-1.6509",
  "seat-types-lib": "static-1.128",
  "ui-addon-opt": "static-4.8410",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3175",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.119",
  "ts-schema": "static-1.4118",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7823",
  "cssUtils": "static-1.803",
  "customer-data-ui-utilities": "static-1.9873",
  "HubStyle": "static-2.11828",
  "knowledge-content-types": "static-1.8512",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.488",
  "ui-addon-emoji-picker": "static-1.9934",
  "ui-addon-i18n": "static-1.11199",
  "ui-business-units-lib": "static-1.9106",
  "ui-shepherd-react": "static-3.10254",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4373",
  "commerce-tours-lib": "static-1.6190",
  "customer-data-properties": "static-1.51735",
  "getting-started-shared-tasks": "static-1.18561",
  "growth-onboarding-reliability": "static-1.5128",
  "onboarding-tours": "static-1.16694",
  "reference-resolvers-lite": "static-1.8144",
  "sales-checkout-service-client": "static-1.3689",
  "ui-addon-iframeable": "static-1.9108",
  "user-context": "static-1.5155",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4689",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.765",
  "quartz-head": "static-1.755",
  "quartz-test": "static-1.765",
  "quartz-tracking": "static-1.469",
  "ui-fonts": "static-1.783",
  "usage-tracker-container": "static-1.7387",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9471",
  "data-token-picker": "static-1.16487",
  "FileManagerLib": "static-1.39386",
  "property-translator": "static-1.5446",
  "atom": "static-1.5122",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.6000",
  "salesImages": "static-1.526",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5505",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1164",
  "bend-plugin-foundations-components": "static-1.4291",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "trellis-assets": "static-1.2069",
  "bend-plugin-foundations-theming": "static-1.2954",
  "foundations-theming-base": "static-1.3456",
  "stylex": "static-1.34",
  "interframe": "static-3.4806",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5811",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.110",
  "chirp-fetch": "static-1.1935",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4523",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4699",
  "content-media-composition-data-lib": "static-1.12503",
  "content-media-compositions": "static-2.16510",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4201",
  "magpie-lib": "static-1.5581",
  "magpie-types": "static-1.5041",
  "media-bridge-lib": "static-1.19009",
  "video-data-lib": "static-1.35106",
  "bender-build-tools": "static-1.3227",
  "inbound-db-properties-service-client": "static-1.3884",
  "superstore": "static-1.4807",
  "feedback-loader": "static-1.29382",
  "ai-components-ui-library": "static-1.9088",
  "ui-addon-video-player": "static-1.8752",
  "ui-coaching-tips": "static-1.28694",
  "sassPrefix": "static-1.157",
  "react-dnd-compat": "static-1.4662",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2546",
  "navigation-messaging": "static-1.7486",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8219",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9739",
  "crm-message-bus": "static-1.43094",
  "growth-data-modal": "static-1.5501",
  "hubspot-apollo-client": "static-1.4926",
  "onboarding-tours-client": "static-1.4908",
  "calling-global-api": "static-1.64679",
  "calling-internal-common": "static-1.31352",
  "calling-lifecycle-internal": "static-1.66061",
  "calling-lifecycle-messages": "static-1.58355",
  "conditional-properties-service-client": "static-1.3836",
  "crm-links": "static-1.6351",
  "crm-pipelines-api-client-types": "static-1.4178",
  "customer-data-objects-ui-components": "static-1.13079",
  "customer-data-properties-shared-msw-handlers": "static-1.9405",
  "customer-data-property-utils": "static-1.8138",
  "external-options-client-types": "static-1.4197",
  "file-manager-components": "static-1.23746",
  "framework-data-schema-resolvers": "static-1.6935",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.215",
  "inbound-db-meta-service-client": "static-1.3624",
  "inbounddb-objects-service-types": "static-1.4261",
  "meetings-icalendar-utils-lib": "static-1.680",
  "multi-currency-client-types": "static-1.3730",
  "object-builder-ui-client": "static-1.48910",
  "pipeline-validation-client-types": "static-1.4004",
  "property-value-citations": "static-1.2349",
  "pulse": "static-1.633",
  "smart-property-lib": "static-1.7349",
  "tiered-pricing": "static-1.1322",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11038",
  "growth-onboarding-confetti": "static-1.3114",
  "growth-onboarding-next-action-utils": "static-1.2058",
  "navigation-components": "static-1.18159",
  "onboarding-tours-utils": "static-1.760",
  "ui-shepherd-tracker": "static-1.7635",
  "ui-universal-auth": "static-1.9035",
  "batch-promise": "static-1.1590",
  "getting-started-shared-tasks-store": "static-1.17679",
  "hubspotter-http-shared-msw-handlers": "static-1.10076",
  "usage-tracker-session-replay": "static-1.5083",
  "audio-components": "static-1.5986",
  "FileManagerCore": "static-1.39245",
  "FileManagerImages": "static-1.36897",
  "video-components": "static-1.13450",
  "foundations-components-legacy": "static-1.1047",
  "purchase-motions-api": "static-1.6003",
  "signup-constants": "static-1.18941",
  "signup-ui-url-generator": "static-2.8102",
  "usage-tracker-public": "static-1.7208",
  "reactive-lib": "static-1.772",
  "simple-logging-lib": "static-1.3099",
  "chatspot-core": "static-1.21499",
  "ContentUtils": "static-1.68505",
  "copilot-toolkit": "static-1.11260",
  "growth-onboarding-feedback-components": "static-1.6627",
  "commerce-permissions": "static-1.821",
  "customer-data-tracking": "static-1.6938",
  "products-iframe-lib": "static-1.8068",
  "products-ui-components-shared-msw-handlers": "static-1.10460",
  "restore-request-side-panel-lib": "static-1.1032",
  "onboarding-data-sync-lib": "static-1.2031",
  "hubspot-apollo-cache": "static-1.385",
  "calling-error-reporting": "static-1.31359",
  "shared-worker-versioning": "static-1.11083",
  "calling-usage-tracker": "static-1.6589",
  "self-service-api": "static-1.10294",
  "voice-sms-access-library": "static-1.1195",
  "conversations-skeleton-state": "static-1.7297",
  "location-customization-utils-lib": "static-1.9400",
  "fdsr-migration-layer": "static-1.54",
  "framework-builder-read-service-client": "static-1.4043",
  "framework-data-schema-quick-fetch": "static-1.6840",
  "persist-promise": "static-1.3747",
  "event-emitter": "static-1.995",
  "bend-plugin-pulse": "static-1.136",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.268",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10161",
  "fsm": "static-1.3778",
  "policy-lib": "static-1.6824",
  "react-tinymce": "static-1.55377",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10224",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54503",
  "tinymce-plugins": "static-1.57617",
  "tinymce-themes": "static-1.56473",
  "growth-onboarding-next-action-components": "static-1.2086",
  "user-context-client": "static-1.4655",
  "nest": "static-1.279",
  "unified-auth-core-lib": "static-1.831",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4586",
  "video-embed": "static-1.35940",
  "content-icons-ui": "static-1.2238",
  "social-insights-client-types": "static-1.22232",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4860",
  "integrations-lib": "static-1.16316",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.822",
  "sales-views-client-types": "static-1.4305",
  "InboxConnectUtils": "static-4.14945",
  "meetings-connect-utils-lib": "static-1.7653",
  "calling-orchestration-schema": "static-1.35972",
  "crm-record-cards-service-types": "static-1.3628",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4561",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3089",
  "tinymce-data": "static-1.40588",
  "ui-addon-sales-email": "static-1.5259",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12535",
  "layout-dnd-utils": "static-1.11510",
  "react-codemirror": "static-1.10676",
  "ui-brand-identity-lib": "static-1.15466",
  "NamespacedHubStyle": "static-2.9097",
  "outpost": "static-1.4224",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13731",
  "integrations-tracking-lib": "static-1.5650",
  "native-integrations-shared-strings": "static-1.7829",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10412",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.549",
  "breeze-engine-core": "static-1.100",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68580",
  "layout-data-lib": "static-1.9835",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3063",
  "google-sheets-integration-lib": "static-1.377",
  "microsoft-drive-integration-lib": "static-1.506",
  "slack-ui-library": "static-1.10440",
  "advanced-menus-core": "static-1.15201",
  "advanced-menus-lib": "static-1.12138",
  "ExportDialog": "static-6.10433",
  "ui-memberships-settings-lib": "static-1.34176",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15200",
  "simple-menus-lib": "static-1.16717"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2454",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.473",
  "data-fetching-client": "/data-fetching-client/static-1.9713",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25516",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5638",
  "hs-test-utils": "/hs-test-utils/static-1.8064",
  "hub-http": "/hub-http/static-1.6270",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10078",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18364",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11521",
  "I18n": "/I18n/static-7.1633",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6512",
  "payment-link-components": "/payment-link-components/static-1.23638",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7090",
  "quartz-core": "/quartz-core/static-1.6309",
  "quartz-i18n": "/quartz-i18n/static-1.765",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10256",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5382",
  "rich-text-lib": "/rich-text-lib/static-1.19912",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18064",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5658",
  "UIComponents": "/UIComponents/static-3.8467",
  "foundations-assets": "/foundations-assets/static-1.4917",
  "foundations-components": "/foundations-components/static-1.8022",
  "foundations-theming": "/foundations-theming/static-1.4471",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2187",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1002",
  "quartz-config": "/quartz-config/static-1.868",
  "quartz-routing": "/quartz-routing/static-1.520",
  "quick-fetch": "/quick-fetch/static-1.3955",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16725",
  "rpc-client-utils": "/rpc-client-utils/static-1.4700",
  "sanitize-text": "/sanitize-text/static-1.8190",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4810",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9589",
  "usage-tracker": "/usage-tracker/static-1.7397",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5814",
  "usage-tracker-core": "/usage-tracker-core/static-1.7247",
  "video-components-external": "/video-components-external/static-1.11448",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3437",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3367",
  "quartz-webpack": "/quartz-webpack/static-1.3314",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.168",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7723",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7974",
  "laboratory-lib": "/laboratory-lib/static-3.7203",
  "onboarding-scopes": "/onboarding-scopes/static-1.6509",
  "seat-types-lib": "/seat-types-lib/static-1.128",
  "ui-addon-opt": "/ui-addon-opt/static-4.8410",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3175",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.119",
  "ts-schema": "/ts-schema/static-1.4118",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7823",
  "cssUtils": "/cssUtils/static-1.803",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9873",
  "HubStyle": "/HubStyle/static-2.11828",
  "knowledge-content-types": "/knowledge-content-types/static-1.8512",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9934",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11199",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9106",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10254",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4373",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6190",
  "customer-data-properties": "/customer-data-properties/static-1.51735",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18561",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5128",
  "onboarding-tours": "/onboarding-tours/static-1.16694",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8144",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9108",
  "user-context": "/user-context/static-1.5155",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4689",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.765",
  "quartz-head": "/quartz-head/static-1.755",
  "quartz-test": "/quartz-test/static-1.765",
  "quartz-tracking": "/quartz-tracking/static-1.469",
  "ui-fonts": "/ui-fonts/static-1.783",
  "usage-tracker-container": "/usage-tracker-container/static-1.7387",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9471",
  "data-token-picker": "/data-token-picker/static-1.16487",
  "FileManagerLib": "/FileManagerLib/static-1.39386",
  "property-translator": "/property-translator/static-1.5446",
  "atom": "/atom/static-1.5122",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.6000",
  "salesImages": "/salesImages/static-1.526",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5505",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1164",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4291",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "trellis-assets": "/trellis-assets/static-1.2069",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2954",
  "foundations-theming-base": "/foundations-theming-base/static-1.3456",
  "stylex": "/stylex/static-1.34",
  "interframe": "/interframe/static-3.4806",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5811",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.110",
  "chirp-fetch": "/chirp-fetch/static-1.1935",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4523",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4699",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12503",
  "content-media-compositions": "/content-media-compositions/static-2.16510",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4201",
  "magpie-lib": "/magpie-lib/static-1.5581",
  "magpie-types": "/magpie-types/static-1.5041",
  "media-bridge-lib": "/media-bridge-lib/static-1.19009",
  "video-data-lib": "/video-data-lib/static-1.35106",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3884",
  "superstore": "/superstore/static-1.4807",
  "feedback-loader": "/feedback-loader/static-1.29382",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9088",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8752",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28694",
  "sassPrefix": "/sassPrefix/static-1.157",
  "react-dnd-compat": "/react-dnd-compat/static-1.4662",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2546",
  "navigation-messaging": "/navigation-messaging/static-1.7486",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8219",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9739",
  "crm-message-bus": "/crm-message-bus/static-1.43094",
  "growth-data-modal": "/growth-data-modal/static-1.5501",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4926",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4908",
  "calling-global-api": "/calling-global-api/static-1.64679",
  "calling-internal-common": "/calling-internal-common/static-1.31352",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66061",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58355",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3836",
  "crm-links": "/crm-links/static-1.6351",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4178",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13079",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9405",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8138",
  "external-options-client-types": "/external-options-client-types/static-1.4197",
  "file-manager-components": "/file-manager-components/static-1.23746",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6935",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.215",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3624",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4261",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.680",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3730",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48910",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4004",
  "property-value-citations": "/property-value-citations/static-1.2349",
  "pulse": "/pulse/static-1.633",
  "smart-property-lib": "/smart-property-lib/static-1.7349",
  "tiered-pricing": "/tiered-pricing/static-1.1322",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11038",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3114",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2058",
  "navigation-components": "/navigation-components/static-1.18159",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.760",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7635",
  "ui-universal-auth": "/ui-universal-auth/static-1.9035",
  "batch-promise": "/batch-promise/static-1.1590",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17679",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10076",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5083",
  "audio-components": "/audio-components/static-1.5986",
  "FileManagerCore": "/FileManagerCore/static-1.39245",
  "FileManagerImages": "/FileManagerImages/static-1.36897",
  "video-components": "/video-components/static-1.13450",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1047",
  "purchase-motions-api": "/purchase-motions-api/static-1.6003",
  "signup-constants": "/signup-constants/static-1.18941",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8102",
  "usage-tracker-public": "/usage-tracker-public/static-1.7208",
  "reactive-lib": "/reactive-lib/static-1.772",
  "simple-logging-lib": "/simple-logging-lib/static-1.3099",
  "chatspot-core": "/chatspot-core/static-1.21499",
  "ContentUtils": "/ContentUtils/static-1.68505",
  "copilot-toolkit": "/copilot-toolkit/static-1.11260",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6627",
  "commerce-permissions": "/commerce-permissions/static-1.821",
  "customer-data-tracking": "/customer-data-tracking/static-1.6938",
  "products-iframe-lib": "/products-iframe-lib/static-1.8068",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10460",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2031",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.385",
  "calling-error-reporting": "/calling-error-reporting/static-1.31359",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11083",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6589",
  "self-service-api": "/self-service-api/static-1.10294",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1195",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7297",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9400",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.54",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4043",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6840",
  "persist-promise": "/persist-promise/static-1.3747",
  "event-emitter": "/event-emitter/static-1.995",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.136",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.268",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10161",
  "fsm": "/fsm/static-1.3778",
  "policy-lib": "/policy-lib/static-1.6824",
  "react-tinymce": "/react-tinymce/static-1.55377",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10224",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54503",
  "tinymce-plugins": "/tinymce-plugins/static-1.57617",
  "tinymce-themes": "/tinymce-themes/static-1.56473",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2086",
  "user-context-client": "/user-context-client/static-1.4655",
  "nest": "/nest/static-1.279",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.831",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4586",
  "video-embed": "/video-embed/static-1.35940",
  "content-icons-ui": "/content-icons-ui/static-1.2238",
  "social-insights-client-types": "/social-insights-client-types/static-1.22232",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4860",
  "integrations-lib": "/integrations-lib/static-1.16316",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.822",
  "sales-views-client-types": "/sales-views-client-types/static-1.4305",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14945",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7653",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35972",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3628",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4561",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3089",
  "tinymce-data": "/tinymce-data/static-1.40588",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5259",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12535",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11510",
  "react-codemirror": "/react-codemirror/static-1.10676",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15466",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9097",
  "outpost": "/outpost/static-1.4224",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13731",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5650",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7829",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10412",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.549",
  "breeze-engine-core": "/breeze-engine-core/static-1.100",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68580",
  "layout-data-lib": "/layout-data-lib/static-1.9835",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3063",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.377",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.506",
  "slack-ui-library": "/slack-ui-library/static-1.10440",
  "advanced-menus-core": "/advanced-menus-core/static-1.15201",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12138",
  "ExportDialog": "/ExportDialog/static-6.10433",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34176",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15200",
  "simple-menus-lib": "/simple-menus-lib/static-1.16717"
}
};
